<fs-dialog>
  <div class="fs-row.align-center.justify-between heading">
    <app-logo width="80"></app-logo>
    <button
      mat-icon-button
      mat-dialog-close
      aria-label="Close"
      type="button"
      tabindex="-1">
      <mat-icon>
        clear
      </mat-icon>
    </button>
  </div>
  <mat-card>
    <mat-card-content>
      @if (step === 0) {
        <app-workspace
          [(environmentCreate)]="environmentCreate"
          (environmentCreateChange)="stepNext()">
        </app-workspace>
      }
      <!-- <app-project
      *ngIf="step === 1"
      [(environmentCreate)]="environmentCreate"
      (environmentCreateChange)="stepNext()"
    ></app-project> -->
    @if (step === 1) {
      <app-invite
        [environmentCreate]="environmentCreate"
        (completed)="close()">
      </app-invite>
    }
    <app-progress [step]="step"></app-progress>
  </mat-card-content>
</mat-card>
</fs-dialog>